// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xDoHSFrsAaoCcb8k{display:inline-block;margin-left:10px;top:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinnerContainer": `xDoHSFrsAaoCcb8k`
};
export default ___CSS_LOADER_EXPORT___;
